export default "__VITE_ASSET__d99ce4f2__"